<template>
  <!-- .stop: the button sits in clickable rows (the help panel opens the request on a row click) -->
  <v-btn
    color="primary"
    size="small"
    :variant="voted ? 'tonal' : 'outlined'"
    :prepend-icon="voted ? 'mdi-thumb-up' : 'mdi-thumb-up-outline'"
    :loading="loading"
    :aria-label="voted ? 'Voted' : 'Vote'"
    @click.stop="emit('click:vote')"
  >
    {{ count }}
  </v-btn>
</template>

<script setup lang="ts">
interface IProps {
  count: number;
  voted: boolean;
  loading?: boolean;
}

interface IEmits {
  'click:vote': [];
}

withDefaults(defineProps<IProps>(), {
  loading: false,
});

const emit = defineEmits<IEmits>();
</script>
